
/* injects from baggage-loader */

'use strict';

export default class ProjectInvestmentWizardController {

	constructor($log, $state, InvestmentWizard) {
		'ngInject';

		this.$log = $log;
		this.$state = $state;
		this.InvestmentWizard = InvestmentWizard;

		// Make sure the wizard returns to step 1 if the page is refreshed
		// if (!this.InvestmentWizard.stepCompleted(0)) {
		// 	this.$state.go('projectinvestmentwizard.start');
		// }

	}

	$onInit() {

		this.$log.log('Current:', this.InvestmentWizard.getCurrentStep());
		this.$log.log('Next:', this.InvestmentWizard.getNextStep());
		this.$log.log('Previous:', this.InvestmentWizard.getPreviousStep());

		// Setup the Investment Wizard
		this.InvestmentWizard.initialize(this.project, this.profile);

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/projectInvestmentWizard/projectinvestmentwizard.controller.js